import(/* webpackMode: "eager" */ "/root/elawphant/src/app/[locale]/prodat-ooo-moskva/page.tsx");
